import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import tools from '../../constants/tools'
import { steps } from '../../constants/steps'
import { onSetRedirectionInfo } from '../reducers/uploadFileReducer';
import { onSetToolAction } from '../reducers/toolLayoutReducer';
import i10n from '../i10n';

class RedirectCompo extends PureComponent {
    render() {
        let tool = Object.values(tools).find(t => t.id == this.props.redirectToWidget);
        var toolsLabel = i10n.getToolLabels(tool);
        return (
            <Link onClick={() => this.props.setStep(steps.upload)} to={{ pathname: tool.url() }}>
                <Button className={`action-button mb-3 ${this.props.backButtonColor} locked-error-buttons`}>
                    {toolsLabel.title}
                </Button>
            </Link >
        );
    }
}

const mapState = ({ files }) => {
    return {
        redirectionStep: files.redirectionStep,
        redirectToWidget: files.redirectToWidget,
        mainTool: files.mainTool,
        toolFiles: files.files
    };
}

const mapDispatch = (dispatch) => {
    return {
        setRedirectionInfo(step, fileToRedirect, redirectToWidget, mainTool) {
            dispatch(onSetRedirectionInfo(step, fileToRedirect, redirectToWidget, mainTool));
        },
        setStep(step) {
            dispatch(onSetToolAction(step));
        }
    }
}

const RedirectComponent = connect(mapState, mapDispatch)(RedirectCompo);
export default RedirectComponent;